<template>
    <div class="clock-wrapper">
        <div class="time-display">
            <div class="time">{{ currentTime }}</div>
            <div class="date-row">
                <span class="date">{{ currentDate }}</span>
                <span class="weekday">{{ currentWeekday }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

const currentTime = ref('');
const currentDate = ref('');
const currentWeekday = ref('');
let timer;

const updateTime = () => {
    const now = dayjs();
    currentTime.value = now.format('HH:mm:ss');
    currentDate.value = now.format('YYYY年MM月DD日');
    currentWeekday.value = now.format('dddd');
};

onMounted(() => {
    updateTime();
    timer = setInterval(updateTime, 1000);
});

onUnmounted(() => {
    clearInterval(timer);
});
</script>

<style scoped>
/* 移除局部字体引入，使用全局字体 */

.clock-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    user-select: none;
}

.time-display {
    text-align: center;
    color: #fff;
    text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.time {
    /* font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif; 使用全局字体 */
    font-variant-numeric: tabular-nums; /* 数字等宽，防止跳动 */
    font-size: 4rem;
    font-weight: 600; /* 稍微减细一点，显得更精致 */
    line-height: 1;
    letter-spacing: -0.02em; /* 稍微紧凑 */
    background: linear-gradient(180deg, #ffffff 0%, #f0f0f0 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    filter: drop-shadow(0 2px 10px rgba(0,0,0,0.1));
}

.date-row {
    margin-top: 10px;
    /* 继承全局字体 */
    font-size: 1.1rem;
    opacity: 0.9;
    display: flex;
    gap: 15px;
    justify-content: center;
    font-weight: 500;
    letter-spacing: 0.5px;
}

.weekday {
    background: rgba(255, 255, 255, 0.2);
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    backdrop-filter: blur(4px);
}

@media (max-width: 768px) {
    .time {
        font-size: 2.5rem;
    }
    .date-row {
        font-size: 0.9rem;
    }
}
</style>
